import {IChapterCue} from '@utils/parseChapterMarks';

export const getChapterIndexByTime = (
    time: number | null,
    cues: IChapterCue[],
) => {
    if (time == null || !cues.length) {
        return 0;
    }

    return cues.findLastIndex(cue => {
        return time >= cue.startTime;
    });
};
